import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery3 = () => (
  <>
    <Table tableData={TABLES.QUERY_3} theme="horizontal" />
    <Table tableData={TABLES.QUERY_3_SECOND} theme="horizontal" />
  </>
);